"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RedeemCard = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_components_1 = __importStar(require("styled-components"));
const i18n_1 = require("@completeanatomy/i18n");
const ui_1 = require("@completeanatomy/ui");
const hooks_1 = require("../../hooks");
const molecules_1 = require("../../molecules");
const providers_1 = require("../../providers");
function RedeemCard({ className }) {
    const { code, error, onCodeChange, canRedeem, redeem, isLoading, popover } = (0, hooks_1.useRedeemCode)();
    const handleRedeemCode = () => __awaiter(this, void 0, void 0, function* () {
        try {
            yield redeem();
        }
        catch (e) {
            console.error(e);
        }
    });
    return ((0, jsx_runtime_1.jsxs)(ui_1.Card, { title: (0, i18n_1.Localized)(i18n_1.Strings.profile.redeem.title), className: className, "data-e2e": 'RedeemCard_Card', children: [(0, jsx_runtime_1.jsx)(FieldTitle, { "data-e2e": 'RedeemCard_FieldTitle', children: (0, i18n_1.Localized)(i18n_1.Strings.profile.redeem.enterCode) }), (0, jsx_runtime_1.jsx)(molecules_1.RedeemCodeInput, { onChange: onCodeChange, code: code, "data-e2e": 'RedeemCard_RedeemCodeInput' }), error && (0, jsx_runtime_1.jsx)(Error, { "data-e2e": 'RedeemCard_Error', children: error.message }), canRedeem && ((0, jsx_runtime_1.jsx)(SendButton, { onClick: handleRedeemCode, disabled: isLoading, "data-e2e": 'RedeemCard_SendButton', children: (0, i18n_1.Localized)(i18n_1.Strings.profile.redeem.button) })), popover] }));
}
const RedeemCardWithPurchasesProvider = (0, providers_1.withPurchasesProvider)(RedeemCard);
exports.RedeemCard = RedeemCardWithPurchasesProvider;
const FieldTitle = styled_components_1.default.div `
  margin: 7px 0 8px 0;

  color: ${({ theme }) => theme.designSystem.textSecondary};

  font-size: 14px;
  line-height: 1.7;
`;
const Error = styled_components_1.default.div `
  margin-bottom: 20px;

  color: ${({ theme }) => theme.designSystem.warning};
  font-size: 12px;
  line-height: 16px;
  text-align: center;
`;
const SendButton = (0, ui_1.withA11y)((0, styled_components_1.default)(ui_1.PrimaryButton) `
  position: relative;

  left: calc(50% - 80px);

  width: 160px;

  margin: 30px auto;
  padding: 14px 0;

  border-radius: 4px;

  &:focus {
    outline-offset: 3px;
  }

  ${ui_1.deviceLandscape.mobileL((0, styled_components_1.css) `
    margin: 16px auto 20px auto;
  `)}
`);
